var _style, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBcuLogoRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 226 454",
    style: {
      enableBackground: "new 0 0 226 454"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t\n\t\t.st0{clip-path:url(#SVGID_00000057836576932628197470000004567441419004493185_);fill:url(#SVGID_00000089540712376170844700000006096532083085174170_);}\n")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: -0.1,
    y: -48.01,
    width: 269.26,
    height: 517.33
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000148628702329198955160000014071989685427042437_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000035526664438615408020000011948541850086725038_",
    gradientUnits: "userSpaceOnUse",
    x1: -225.6071,
    y1: 227.1431,
    x2: 225.4129,
    y2: 227.1431
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.002180233,
    style: {
      stopColor: "#009EE2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#7DB828"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000148628702329198955160000014071989685427042437_)",
      fill: "url(#SVGID_00000035526664438615408020000011948541850086725038_)"
    },
    d: " M-21.73,249.91c8.67,7.98,22.22,7.42,30.2-1.25L73,178.58c7.98-8.67,7.42-22.21-1.25-30.2l-0.57-0.53 c-4.18-3.85-9.63-5.84-15.35-5.6c-5.72,0.24-10.99,2.67-14.84,6.85l-64.53,70.08c-7.98,8.67-7.42,22.21,1.25,30.2L-21.73,249.91z  M-32.4,152.99l-0.57-0.52c-4.18-3.85-9.64-5.84-15.36-5.61c-5.72,0.24-10.99,2.67-14.84,6.85l-64.53,70.08 c-7.98,8.67-7.42,22.21,1.25,30.2l0.57,0.53c8.67,7.98,22.21,7.42,30.2-1.25l64.53-70.08C-23.17,174.52-23.73,160.97-32.4,152.99z  M3.62,135.8c11.9-0.49,21.19-10.58,20.7-22.48c-0.49-11.9-10.58-21.19-22.48-20.7c-11.9,0.49-21.19,10.58-20.7,22.48 C-18.37,127-8.28,136.29,3.62,135.8z M-58.32,266.57c-11.9,0.49-21.19,10.58-20.7,22.48c0.24,5.77,2.71,11.1,6.95,15.01 c4.25,3.91,9.76,5.93,15.53,5.69c11.9-0.49,21.19-10.58,20.7-22.48C-36.33,275.37-46.42,266.08-58.32,266.57z M225.22,217.85 C220.09,93.61,114.85-3.3-9.39,1.83C-133.63,6.95-230.54,112.2-225.41,236.44c5.12,124.24,110.37,221.14,234.61,216.02 C133.44,447.33,230.34,342.09,225.22,217.85z M8.11,426.25c-109.79,4.53-202.79-81.11-207.32-190.9 c-4.53-109.79,81.11-202.8,190.9-207.32c109.79-4.53,202.8,81.11,207.32,190.9C203.54,328.72,117.91,421.72,8.11,426.25z  M75.28,252.13c-4.18-3.85-9.63-5.84-15.35-5.6c-5.72,0.24-10.99,2.67-14.84,6.85l-64.53,70.08c-7.98,8.67-7.42,22.22,1.25,30.2 l0.57,0.53c8.67,7.98,22.21,7.42,30.2-1.25l64.53-70.08c7.98-8.67,7.42-22.21-1.25-30.2L75.28,252.13z M110.09,192.29 c-11.9,0.49-21.19,10.58-20.7,22.48c0.49,11.9,10.58,21.19,22.48,20.7c11.9-0.49,21.19-10.58,20.7-22.48 C132.08,201.09,121.99,191.8,110.09,192.29z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBcuLogoRight);
export default __webpack_public_path__ + "static/media/bcu_logo_right.4063a43b6380bba63d3d63ea5a562d84.svg";
export { ForwardRef as ReactComponent };